import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { isAuthTransitionInProgress } from "../utils/impersonation";

const PrivateRoute = ({ children }) => {
  const { loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading || isAuthTransitionInProgress()) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <i className="fas fa-spinner fa-spin text-4xl text-primary-600 mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirectTo = location.pathname + location.search;
    const urlParams = new URLSearchParams(location.search);
    const email = urlParams.get("email");

    let loginUrl = `/login?redirect=${encodeURIComponent(redirectTo)}`;

    if (email) {
      loginUrl += `&email=${encodeURIComponent(email)}`;
    }

    return <Navigate to={loginUrl} />;
  }

  return children;
};

export default PrivateRoute;
